import { configConstants } from '../_constants';

const INITIAL = {
  loading: true,
  config: [],
  setup: []
};

function config(state = INITIAL, action) {
  switch (action.type) {
    case configConstants.CONFIG_REQUEST:
      return {
        ...state,
        loading: true
      };
    case configConstants.CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.config
      };
    case configConstants.CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        config: [],
        error: action.error
      };
    case configConstants.CONFIG_SETUP_REQUEST:
      return {
        ...state,
        loading: true
      };
    case configConstants.CONFIG_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        setup: action.setup
      };
    case configConstants.CONFIG_SETUP_FAILURE:
      return {
        ...state,
        loading: false,
        setup: [],
        error: action.error
      };
    case configConstants.CONFIG_UPD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case configConstants.CONFIG_UPD_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.config
      };
    case configConstants.CONFIG_UPD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case configConstants.CONFIG_VAL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case configConstants.CONFIG_VAL_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case configConstants.CONFIG_VAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}

export default config;
